<app-loader *ngIf="loaderService.loading$ | async"></app-loader>
<!-- Fixed Header -->
<app-header class="fixed top-0 left-0 w-full z-50"></app-header>

<!-- Main page content -->
<div class="pt-16 min-h-screen flex flex-col">
  <router-outlet></router-outlet>
</div>

<!-- Footer -->
<app-footer></app-footer>
